/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {CensusGeo} from './census.geo';

export class ContentRequest {
  EFFECTIVE_DATE: string;
  LOCATIONS: Location[];
  NON_LOCATION_SPECIFIC: boolean;
  IBIS: number;

  constructor(values: any = {}){
    Object.assign(this, values);

    if(values)
      this.LOCATIONS = Location.parseArray(values.LOCATIONS);
  }
}

export class Location {
  ADDRESS: string;
  CITY: string;
  STATE: string;
  ZIP: string;
  CENSUS: CensusGeo;

  constructor(values: Object = {}) {
    Object.assign(this, values);
  }

  static parseArray(json: any[]): Location[] {
    const arr = [];

    if (json)
      for (const j of json)
        if (j)
          arr.push(new Location(j));

    return arr;
  }
}

export class District{
  NAME: string;
  ADDRESS: string;
  NUMBER: string;
  WEB: string;
  RATING: Number;
  ID: number;

  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}
